import type { Quotation } from '~/api/quotations/types';

import { Separator } from '~/components';

import type { DialogHandles } from '../QuotationsTable.hooks';

import { mobileActionsStyle, mobileCellStyle, mobileFooterStyle, mobileHeaderStyle, mobileSeparatorStyle } from './quotationCell.css';
import { QuotationClientCell } from './QuotationClientCell';
import { QuotationDocumentDateCell } from './QuotationDocumentDateCell';
import { QuotationOptionsCell } from './QuotationOptionsCell';
import { QuotationStatusCell } from './QuotationStatusCell';
import { QuotationTitleCell } from './QuotationTitleCell';
import { QuotationTotalCell } from './QuotationTotalCell';

type Props = {
  dialogHandles: DialogHandles;
  quotation: Quotation;
};

export const QuotationMobileCell = ({ dialogHandles, quotation }: Props) => {
  // TODO: add correct aria labels.
  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <div>
          <QuotationTitleCell quotation={quotation} />

          <QuotationClientCell quotation={quotation} />
        </div>

        <div className={mobileActionsStyle}>
          <QuotationStatusCell quotation={quotation} />

          <QuotationOptionsCell dialogHandles={dialogHandles} quotation={quotation} />
        </div>
      </div>

      <Separator className={mobileSeparatorStyle} />

      <div className={mobileFooterStyle}>
        <QuotationDocumentDateCell quotation={quotation} />

        <QuotationTotalCell value={quotation.calculationData.coExclVat} />
      </div>
    </div>
  );
};
